export default __webpack_public_path__ + "static/media/googleLogoDisabled.63eac8e0.svg";